import ErrorBanner from "components/ui/ErrorBanner";
import classnames from "classnames";
import { ReactNode } from "react";
import { ErrorBoundary } from "components/ErrorBoundary";
import "./PageWithHeaderFooter.css";

type PageWithHeaderFooterProps = {
  children: ReactNode;
  className?: string;
  footer?: ReactNode;
  header?: ReactNode;
  pathname?: string;
};

export default function PageWithHeaderFooter(props: PageWithHeaderFooterProps) {
  return (
    <div className={classnames("PageWithHeaderFooter", props.className)}>
      <ErrorBoundary fallback={<ErrorBanner>Something went wrong.</ErrorBanner>}>
        {props.header}
      </ErrorBoundary>
      <ErrorBoundary pathname={props.pathname}>{props.children}</ErrorBoundary>
      <ErrorBoundary fallback={<ErrorBanner>Something went wrong.</ErrorBanner>}>
        {props.footer}
      </ErrorBoundary>
    </div>
  );
}
